// src/main.js
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import App from './App.vue'
import router from './router'

// Handsontable 全局样式（必须全局引入，scoped 下主题 CSS 不生效）
import 'handsontable/styles/handsontable.css'
import 'handsontable/styles/ht-theme-main.css'

// Suppress Element Plus deprecation warnings (label→value migration is internal, not our code)
const originalWarn = console.warn
console.warn = (...args) => {
  const msg = args[0]
  if (typeof msg === 'string' && msg.includes('[el-radio]') && msg.includes('label act as value')) return
  originalWarn.apply(console, args)
}

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(ElementPlus, { locale: zhCn })

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.mount('#app')
